import React from 'react';

const fileIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

export function FileCard({
  variant = 'shared',
  title,
  subtitle,
  metaRight,
  children,
  className = '',
}) {
  if (variant === 'owned') {
    return (
      <div
        className={`
          user-dash-owned-card user-dash-file-unified group flex items-center gap-3 rounded-2xl border border-gray-200/90 bg-white/95 px-4 py-3.5 shadow-sm backdrop-blur-sm
          transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]
          hover:-translate-y-0.5 hover:border-indigo-200/80 hover:shadow-md hover:shadow-indigo-500/5
          dark:border-slate-600/70 dark:bg-slate-800/85 dark:hover:border-indigo-500/45 dark:hover:shadow-lg dark:hover:shadow-indigo-500/5
          ${className}
        `.trim().replace(/\s+/g, ' ')}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={`
        user-dash-shared-card user-dash-file-unified group flex flex-col rounded-2xl border border-gray-200/90 bg-white/95 p-4 shadow-sm backdrop-blur-sm
        transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]
        hover:-translate-y-0.5 hover:border-indigo-200/80 hover:shadow-md hover:shadow-indigo-500/5
        dark:border-slate-600/70 dark:bg-slate-800/85 dark:hover:border-indigo-500/45 dark:hover:shadow-lg dark:hover:shadow-indigo-500/5
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 transition-transform duration-300 group-hover:scale-105 dark:bg-indigo-500/10 dark:text-indigo-400">
          {fileIcon}
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[13px] font-semibold text-gray-900 dark:text-slate-100">{title}</div>
          <div className="mt-0.5 truncate text-[11px] font-medium text-gray-500 dark:text-slate-400">{subtitle}</div>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-end gap-2">{metaRight}</div>
    </div>
  );
}

export default FileCard;
